import React, { FunctionComponent } from "react";
import {
  Button, ButtonSize, CallToActionLink, ButtonColour,
} from "@trussle/external-components";
import { Link } from "gatsby";
import { ICTA } from "../../types/ICTA";
import { ReplaceQueryParams } from "../ReplaceQueryParams";
import "./styles.scss";

export interface IProps extends ICTA {
  size: ButtonSize;
  buttonClasses: string;
  ctaColour: ButtonColour;
  isInternal: boolean;
  id?: string;
  style?: React.CSSProperties;
}

export const InternalCTALink: FunctionComponent<IProps> = (props) => {
  const {
    url,
    title,
    subtitle,
    size,
    buttonClasses,
    ctaColour,
    handleClick,
    isInternal,
    style,
    ...rest
  } = props;

  const body = (
    <>
      <span className="cta-wrapper__text">
        <ReplaceQueryParams>{title}</ReplaceQueryParams>
      </span>
      {subtitle && (
        <span className="cta-wrapper__subtitle">
          <ReplaceQueryParams>{subtitle}</ReplaceQueryParams>
        </span>
      )}
    </>
  );

  return isInternal ? (
    <Link
      to={url}
      onClick={(e) => handleClick && handleClick(e)}
      className="cta-outer-wrapper"
      data-testid="gatsby-link"
    >
      <Button
        size={size}
        colour={ctaColour}
        classOverrides={{ button: buttonClasses }}
        style={style}
        fixed={false}
      >
        {body}
      </Button>
    </Link>
  ) : (
    <CallToActionLink
      {...rest}
      href={url}
      size={size}
      colour={ctaColour}
      classOverrides={{ anchor: buttonClasses }}
      style={style}
      onClick={(e) => handleClick && handleClick(e)}
      data-testid="external-link"
    >
      {body}
    </CallToActionLink>
  );
};
